module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=HK - Hong Kong.2926e05f.svg";